import { getArticle } from '../../api/datamining'
// import { OrigionHtml, OriginYaoExtract } from '../../api/xExtract'
import { formatHtml, formatHtml2 } from '../../utils/utils'
import { formatRedTitle } from '../../filters'

const readModle = window.localStorage.getItem('FnArticleReadModle')

const user = {
  namespaced: true,
  state: {
    id: null,
    details: {},
    loading: false,
    isMore: false,
    redKey: '',
    htmlStr: '',
    titleStr: '',
    quoteStr: '',
    rules: [],
    readModle: readModle ? JSON.parse(readModle) : {
      viewType: 0, // 0：原始浏览， 1：纯净浏览
      tsType: 0, // 0：简体， 1：繁体
      fontSize: 12
    }
  },

  mutations: {
    SET_REDMODLE: (state, readModle) => {
      state.readModle = readModle
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_RULES: (state, rules) => {
      state.rules = rules
    },
    SET_REDKEY: (state, id) => {
      state.redKey = id
    },
    SET_DETAILS: (state, details) => {
      state.details = details
    },
    SET_ISMORE: (state, isMore) => {
      state.isMore = isMore
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading
    },
    setOriginHtml(state, { htmlStr, val }) {
      let rules1 = []
      let rules2 = [] // 标题
      let rules3 = [] // 引题
      if (Array.isArray(val)) {
        val.forEach(item => {
          if (Array.isArray(item)) {
            item.forEach(t => {
              if (t.itemForColumn === 1) {
                rules2.push(t)
              } else if (t.itemForColumn === 2) {
                rules3.push(t)
              } else {
                rules1.push(t)
              }
            })
          } else {
            if (item.itemForColumn === 1) {
              rules2.push(item)
            } else if (item.itemForColumn === 2) {
              rules3.push(item)
            } else {
              rules1.push(item)
            }
          }
        })
      }
      state.htmlStr = formatRedTitle(formatHtml2(htmlStr, rules1), state.redKey)
    },
    setHtml(state, val) {
      let rules1 = []
      let rules2 = [] // 标题
      let rules3 = [] // 引题
      if (Array.isArray(val)) {
        val.forEach(item => {
          if (Array.isArray(item)) {
            item.forEach(t => {
              if (t.itemForColumn === 1) {
                rules2.push(t)
              } else if (t.itemForColumn === 2) {
                rules3.push(t)
              } else {
                rules1.push(t)
              }
            })
          } else {
            if (item.itemForColumn === 1) {
              rules2.push(item)
            } else if (item.itemForColumn === 2) {
              rules3.push(item)
            } else {
              rules1.push(item)
            }
          }
        })
      }
      // if (Number(state.readModle.viewType) === 3) {
      //   state.details.contentTxt = state.details.contentTxt.replace(/\\n/g, '/n')
      //   debugger
      // }
      // debugger
      state.htmlStr = formatRedTitle(formatHtml2(state.details.contentTxt, rules1), state.redKey)
      state.titleStr = formatRedTitle(formatHtml2(state.details.title, rules2), state.redKey)
      state.quoteStr = formatRedTitle(formatHtml2(state.details.parentTitle, rules3), state.redKey)
    }
  },

  actions: {
    // 获取阅读模式
    setRedModle({ commit }, readModle) {
      return new Promise(resolve => {
        window.localStorage.setItem('FnArticleReadModle', JSON.stringify(readModle))
        commit('SET_REDMODLE', readModle)
        resolve()
      })
    },
    updateData({ dispatch, commit, state }, data) {
      let { articleId, rules, redKey } = data || {}
      state.htmlStr = ''
      state.redKey = redKey
      if (!articleId) return
      state.rules = rules || []
      if (state.id !== articleId) {
        state.id = articleId
        state.article = {}
        return dispatch('getArticle', articleId).then(res => {
          commit('setHtml', rules, redKey)
          return rules
        })
      } else {
        commit('setHtml', rules, redKey)
        return rules
      }
    },
    getOrigionArticle({ commit, state }, { id, path, channelId }) {
      let { url } = state.details
      state.id = id || state.id
      state.loading = false
      state.isEnd = false
      return new Promise((resolve, reject) => {
        resolve()
        // OrigionHtml({
        //   channelId,
        //   articleId: state.id,
        //   originUrl: path || url
        // }).then(res => {
        //   state.isEnd = false
        //   state.loading = true
        //   // state.details = res.data
        //   resolve(res.data)
        // }).catch((err) => {
        //   // state.details = {}
        //   state.isEnd = true
        //   reject(err)
        // }).finally(() => {
        // })
      })
    },
    getArticle({ commit, state }, id) {
      state.id = id || state.id
      state.loading = false
      state.isEnd = false
      return new Promise((resolve, reject) => {
        getArticle({ id: state.id, ...state.readModle }).then(res => {
          state.isEnd = false
          state.loading = true
          state.details = res.data
          resolve()
        }).catch((err) => {
          state.details = {}
          state.isEnd = true
          reject(err)
        }).finally(() => {
        })
      })
    }
  }
}

export default user
